/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Fonts_Empty_StateInputs */

const en_options_fonts_empty_state = /** @type {(inputs: Options_Fonts_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No fonts added yet. Add system fonts above to use in your captions.`)
};

const fr_options_fonts_empty_state = /** @type {(inputs: Options_Fonts_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune police ajoutée. Ajoutez des polices système ci-dessus pour vos sous-titres.`)
};

const de_options_fonts_empty_state = /** @type {(inputs: Options_Fonts_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurden noch keine Schriftarten hinzugefügt. Fügen Sie oben Systemschriftarten hinzu, die Sie in Ihren Bildunterschriften verwenden möchten.`)
};

const it_options_fonts_empty_state = /** @type {(inputs: Options_Fonts_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun font aggiunto ancora. Aggiungi i font di sistema qui sopra da utilizzare nelle didascalie.`)
};

const ru_options_fonts_empty_state = /** @type {(inputs: Options_Fonts_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шрифты пока не добавлены. Добавьте системные шрифты выше, чтобы использовать их в подписях.`)
};

const es_options_fonts_empty_state = /** @type {(inputs: Options_Fonts_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no se han añadido fuentes. Añade las fuentes del sistema arriba para usarlas en tus subtítulos.`)
};

const zh_cn2_options_fonts_empty_state = /** @type {(inputs: Options_Fonts_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未添加任何字体。请在上方添加系统字体，以便在字幕中使用。`)
};

const ja_options_fonts_empty_state = /** @type {(inputs: Options_Fonts_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだフォントが追加されていません。キャプションで使用するには、上記のシステムフォントを追加してください。`)
};

const hi_options_fonts_empty_state = /** @type {(inputs: Options_Fonts_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी तक कोई फ़ॉन्ट नहीं जोड़ा गया है। अपने कैप्शन में उपयोग करने के लिए ऊपर दिए गए सिस्टम फ़ॉन्ट जोड़ें।`)
};

const pt_pt2_options_fonts_empty_state = /** @type {(inputs: Options_Fonts_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma fonte foi adicionada ainda. Adicione fontes do sistema acima para usar em suas legendas.`)
};

/**
* | output |
* | --- |
* | "No fonts added yet. Add system fonts above to use in your captions." |
*
* @param {Options_Fonts_Empty_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_fonts_empty_state = /** @type {((inputs?: Options_Fonts_Empty_StateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Fonts_Empty_StateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_fonts_empty_state(inputs)
	if (locale === "de") return de_options_fonts_empty_state(inputs)
	if (locale === "it") return it_options_fonts_empty_state(inputs)
	if (locale === "ru") return ru_options_fonts_empty_state(inputs)
	if (locale === "es") return es_options_fonts_empty_state(inputs)
	if (locale === "zh-CN") return zh_cn2_options_fonts_empty_state(inputs)
	if (locale === "ja") return ja_options_fonts_empty_state(inputs)
	if (locale === "hi") return hi_options_fonts_empty_state(inputs)
	if (locale === "pt-PT") return pt_pt2_options_fonts_empty_state(inputs)
	return en_options_fonts_empty_state(inputs)
});